<template>
  <transition name="fade">
  <div class="sceneorder">
    <h1>Choose Your Track</h1>
    <p>The whole household is encouraged to participate.
      Each person should choose a different track.</p>
    <div>
      <button :class="{active:scene_order===1, track: true}" @click="choose(1)">
        Table Track
      </button>
    </div>
    <div>
      <button :class="{active:scene_order===2, track: true}" @click="choose(2)">
        Couch Track
      </button>
    </div>
    <div>
      <button :class="{active:scene_order===3, track: true}" @click="choose(3)">
        Chair Track
      </button>
    </div>
    <div>
      <button :class="{active:scene_order===4, track: true}" @click="choose(4)">
        Tub Track
      </button>
    </div>

    <p class="bottomspacer">Press "play" together when everyone's ready.</p>

    <div class="bottom-control">
      <button class="play" @click="play" :disabled="!scene_order">
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" fill="currentColor" class="bi bi-play" viewBox="0 0 14 14">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z"/>
          </svg>
        </div>
        <div>Play</div>
      </button>
      <div class="seek">0</div>
    </div>
  </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SceneOrder',
  components: {
  },
  props: {
  },
  data () {
    return {
      shown: true,
      // chosen: null,
    }
  },
  methods: {
    choose(n) {
      console.log("choose", n);
      this.$store.commit('scene_order', n);
    },
    play() {
      console.log("note play", this.key);
      const params = {
          key: this.key,
      };
      const options = {
          method: 'POST',
          body: JSON.stringify( params ),
      };
      fetch('https://strangebirdimmersive.com/homeproj/play', options )
          .then( response => response.text() )
          .then( response => {
              // Do something with response.
              console.log(response);
          } );

      this.$router.push('scene/1');
    },
  },
  computed: {
    ...mapState(['scene_order', 'key']),
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fullscreen {
  overflow: scroll;
}

button.track {
  width: 50%;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-bottom: 3vh;
}

button.active {
  background-color: #555;
  color: white;
}

button.play {
  height: 6rem;
  width: 6rem;
  border-radius: 50%;
}

button .icon {
  width: 85%;
  height: 75%;
  margin-left: auto;
  margin-right:auto;
}

.seek {
  padding-top: 0.5rem;
  color: white;
}

</style>
